/**
 * Navigation Tracker Component
 *
 * Automatically tracks all page navigation events and logs them to Sentry
 */

import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { logger } from "../utils/sentryLogger";

/**
 * Navigation tracker component - Add this to your App component
 */
export const NavigationTracker = () => {
  const location = useLocation();
  const prevLocationRef = useRef(location.pathname);

  useEffect(() => {
    const prevPath = prevLocationRef.current;
    const currentPath = location.pathname;

    // Only track if path actually changed
    if (prevPath !== currentPath) {
      // Track navigation
      logger.trackNavigation(prevPath, currentPath);

      // Add detailed page view breadcrumb
      logger.addBreadcrumb(
        `Page view: ${currentPath}`,
        "info",
        {
          path: currentPath,
          search: location.search,
          hash: location.hash,
          previousPath: prevPath,
        },
        "navigation"
      );

      // Update tag for current page
      logger.setTag("current_page", currentPath);

      // Track page views as info
      logger.info(`Navigated to ${currentPath}`, {
        from: prevPath,
        search: location.search,
        hash: location.hash,
      });

      // Update prev location
      prevLocationRef.current = currentPath;
    }
  }, [location]);

  return null; // This component doesn't render anything
};

export default NavigationTracker;
